import { Button, Form, message, Modal, Upload } from 'antd';
import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import style from './BackupImportExport.module.css';

import { authService, serviceBundler } from '../../../../App';
import { useNavigate } from 'react-router-dom';

import { Space, Table, Tag } from 'antd';
import type { TableProps, UploadProps } from 'antd';

import {
  HomeOutlined,
  TabletOutlined,
  SettingOutlined,
  KeyOutlined,
  UploadOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { create } from 'domain';
import { LanguageHelper } from '../../../../Helpers/LanguageHelper';
import { SettingsWebportalHelper } from '../../../../Helpers/SettingsWebportalHelper';
import { SettingsWebPortal } from '../../../../Models/Settings/SettingsWebportal';

interface DataType {
  key: string;
  name: string;
}

const data: DataType[] = [
  {
    key: '1',
    name: 'Webportaal instellingen',
  },
  {
    key: '2',
    name: 'Taal bestanden',
  },
  {
    key: '3',
    name: 'Apparaat instellingen',
  },
  {
    key: '4',
    name: 'Productie',
  },
];

export function BackupImportExport(props: {
  open: boolean;
  onCancel: Function;
}) {
  const { i18n, t } = useTranslation();

  useEffect(() => {
    serviceBundler.tourService.TourStart.subscribe((value) => {
      if (value) {
        props.onCancel();
      }
    });
  }, [0]);

  const handleCancel = () => {
    serviceBundler.tourService.EndAllTours();
    props.onCancel();
  };

  function CreateUploadProps(actionUrl: string, token: string): UploadProps {
    return {
      name: 'file',
      action: actionUrl,
      headers: {
        authorization: token,
      },
      beforeUpload: (file) => {
        const isJson = file.type === 'application/json';
        if (!isJson) {
          message.error(`${file.name} is not a json file`);
        }
        return isJson || Upload.LIST_IGNORE;
      },
      onChange(info) {
        if (info.file.status !== 'uploading') {
          var js = info.file.response as SettingsWebPortal;
          console.log('response', js.availableSounds);

        }
        if (info.file.status === 'done') {
          message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
    };
  }

  const UploadProps = (): UploadProps => {
    console.log(
      'CreateUploadProps',
      SettingsWebportalHelper.ImportSettingWebportal(),
    );
    console.log('token', authService.GetToken());
    console.log(
      'CreateUploadProps',
      CreateUploadProps(
        SettingsWebportalHelper.ImportSettingWebportal(),
        authService.GetToken(),
      ),
    );
    return CreateUploadProps(
      SettingsWebportalHelper.ImportSettingWebportal(),
      authService.GetToken(),
    );
  };

  const columns: TableProps<DataType>['columns'] = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Importeer',
      key: 'Importeer',
      render: (_, record) => (
        <Space size="middle">
          <Upload
            {...UploadProps()}
            maxCount={1}
            accept=".json"
            showUploadList={false}
          >
            <Button
              onClick={() => ImportFromExcel(_)}
              type="primary"
              icon={<UploadOutlined />}
            >
              Importeer
            </Button>{' '}
          </Upload>
        </Space>
      ),
    },
    {
      title: 'Export',
      key: 'export',
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => ExportToExcel(_)}
            type="primary"
            icon={<DownloadOutlined />}
          >
            Exporteer
          </Button>
        </Space>
      ),
    },
  ];

  const ExportToExcel = (record: any) => {
    if (record.key === '1') {
      CreateBackupWebSetting();
    } else if (record.key === '2') {
      CreateBackupLangauges();
    } else if (record.key === '3') {
      CreateBackupNotiDevices();
    } else if (record.key === '4') {
      CreateBackupProduction;
    }
  };

  const ImportFromExcel = (record: any) => {
    if (record.key === '1') {
      ImportBackupWebSetting();
    } else if (record.key === '2') {
      ImportBackupLangauges();
    } else if (record.key === '3') {
      ImportBackupNotiDevices();
    } else if (record.key === '4') {
      ImportBackupProduction();
    }
  };

  const CreateBackupWebSetting = async () => {
    serviceBundler.settingsWebportalService.ExportSetting();
  };

  const CreateBackupLangauges = () => {
    serviceBundler.languageService.ExportLanguages();
  };

  const CreateBackupNotiDevices = () => {
    serviceBundler.devicesService.ExportDevices();
  };
  const CreateBackupProduction = () => {
    serviceBundler.productionOverviewService.ExportProductionOverviews();
  };

  const ImportBackupWebSetting = async () => {
    // serviceBundler.settingsWebportalService.ExportSetting();
  };

  const ImportBackupLangauges = () => {
    // serviceBundler.languageService.ExportLanguages();
  };

  const ImportBackupNotiDevices = () => {
    // serviceBundler.devicesService.ExportDevices();
  };
  const ImportBackupProduction = () => {
    // serviceBundler.productionOverviewService.ExportProductionOverviews();
  };

  return (
    <div style={{ zIndex: 10000 }}>
      <Modal
        title={'Backups maken en importeren'}
        open={props.open}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={() => handleCancel()}>
            {t('cancel')}
          </Button>,
        ]}
      >
        <Table<DataType>
          columns={columns}
          dataSource={data}
          pagination={false}
        />
      </Modal>
    </div>
  );
}
